const LS_BASE = ["XS","S","M","L","XL","2XL","3XL"];
const LS_UP_4XL = ["XS","S","M","L","XL","2XL","3XL","4XL"];
const LS_DOWN_2XL = ["XS","S","M","L","XL","2XL"];

window.APPAREL_RULES = {
  Toddler: {
    BC: {
      "Short Sleeve": {
        "3001T": {
          colors: {
            "White": ["2T","3T","4T","5T","6T"],
            "Natural": ["2T","3T","4T","5T","6T"],
            "Heather Dust": ["2T","3T","4T","5T","6T"],
            "Heather Athletic": ["2T","3T","4T","5T","6T"],
            "Heather Stone": ["2T","3T","4T","5T"],
            "Storm": ["2T","3T","4T","5T","6T"],
            "Heather Deep": ["2T","3T","4T","5T"],
            "Asphalt": ["2T","3T","4T","5T","6T"],
  
            // "Gray Triblend": ["2T","3T","4T","5T"],
  
            "Heather Dark Gray": ["2T","3T","4T","5T","6T"],
            "Dark Gray": ["2T","3T","4T","5T"],
            // "Charcoal Black Tri": ["2T","3T","4T","5T"],
            "Black": ["2T","3T","4T","5T","6T"],
            "Solid Black Blend": ["2T","3T","4T","5T"],
            "Vintage Black": ["2T","3T","4T","5T"],
            "Solid Athletic Gray": ["2T","3T","4T","5T"],
            "Heather Red": ["2T","3T","4T","5T","6T"],
            "Heather Yellow Gold": ["2T","3T","4T","5T","6T"],
            "Yellow": ["2T","3T","4T","5T","6T"],
            "Pink": ["2T","3T","4T","5T","6T"],
            "Heather Mauve": ["2T","3T","4T","5T","6T"],
            "Red": ["2T","3T","4T","5T","6T"],
            "Maroon": ["2T","3T","4T","5T"],
            "Heather Maroon": ["2T","3T","4T","5T"],
            "Heather Deep Teal": ["2T","3T","4T","5T"],
            "Military Green": ["2T","3T","4T","5T"],
            "Olive": ["2T","3T","4T","5T","6T"],
            "Kelly": ["2T","3T","4T","5T","6T"],
            "Forest": ["2T","3T","4T","5T","6T"],
            "Dusty Blue": ["2T","3T","4T","5T"],
            "Heather Columbia Blue": ["2T","3T","4T","5T"],
            "Heather True Royal": ["2T","3T","4T","5T"],
            "True Royal": ["2T","3T","4T","5T","6T"],
            "Heather Navy": ["2T","3T","4T","5T","6T"],
            "Navy": ["2T","3T","4T","5T","6T"],
            "Heather Team Purple": ["2T","3T","4T","5T"],
            "Team Purple": ["2T","3T","4T","5T","6T"]
          }
        }
      }
    },
  
    RS: {
      "Long Sleeve": {
        "3311": {
          colors: {
            "White": ["2","3","4","5/6"],
            "Heather": ["2","3","4","5/6"],
            "Black": ["2","3","4","5/6"],
            "Orange": ["2","3","4","5/6"],
            "Pink": ["2","3","4","5/6"],
            "Red": ["2","3","4","5/6"],
            "Light Blue": ["2","3","4","5/6"],
            "Royal": ["2","3","4","5/6"],
            "Navy": ["2","3","4","5/6"],
            "Purple": ["2","3","4","5/6"]
          }
        }
      },
  
      "Sweatshirt": {
        "3317": {
          colors: {
            "White": ["2","3","4","5/6","7"],
            "Natural": ["2T","3T","4T","5/6","7"],
            "Natural Heather": ["2","3","4","5/6","7"],
            "Heather": ["2","3","4","5/6","7"],
            "Granite Heather": ["2","3","4","5/6","7"],
            "Charcoal": ["2T","3T","4T","5/6","7"],
            "Black": ["2","3","4","5/6","7"],
            "Pink": ["2","3","4","5/6","7"],
            "Mauvelous": ["2","3","4","5/6","7"],
            "Red": ["2","3","4","5/6","7"],
            "Vintage Camo": ["2","3","4","5/6","7"],
            "Saltwater": ["2","3","4","5/6","7"],
            "Chill": ["2","3","4","5/6","7"],
            "Royal": ["2","3","4","5/6","7"],
            "Navy": ["2","3","4","5/6","7"],
            "Lavender": ["2","3","4","5/6","7"],
            "Coyote Brown": ["2","3","4","5/6","7"]
          }
        }
      },
  
      "Hoodie": {
        "3326": {
          colors: {
            "White": ["2","4","5/6"],
            "Natural Heather": ["2","4","5/6"],
            "Heather": ["2","4","5/6"],
            "Granite Heather": ["2","4","5/6"],
            "Vintage Smoke": ["2","4","5/6"],
            "Storm Camo": ["2","4","5/6"],
            "Black": ["2","4","5/6"],
            "Black Leopard": ["2","4","5/6"],
            "BAMBOO BLACKOUT": ["2T","4T","5/6"],
            "Orange": ["2","4","5/6"],
            "Pink": ["2","4","5/6"],
            "Raspberry": ["2","4","5/6"],
            "Vintage Hot Pink": ["2","4","5/6"],
            "Red": ["2","4","5/6"],
  
            // "Vintage Red": ["2","4","5/6"],
  
            "Vintage Camo": ["2","4","5/6"],
            "Kelly": ["2","4","5/6"],
            "Military Green": ["2","4","5/6"],
            "Chill": ["2","4","5/6"],
            "Turquoise": ["2","4","5/6"],
            "Royal": ["2","4","5/6"],
            "Vintage Royal": ["2","4","5/6"],
            "Navy": ["2","4","5/6"],
            "Purple": ["2","4","5/6"],
            "Mauvelous": ["2","4","5/6"],
            "Saltwater": ["2","4","5/6"],
            "BERMUDA BLACKOUT": ["2T","4T","5/6"]
          }
        }
      }
    }
  },

  Youth: {
    GL: {
      "Short Sleeve": {
        "G640B": {
          colors: {
            "White": ["XS","S","M","L","XL"],
            "Natural": ["XS","S","M","L","XL"],
            "RS Sport Grey": ["XS","S","M","L","XL"],
            "Graphite Heather": ["XS","S","M","L","XL"],
            "Charcoal": ["XS","S","M","L","XL"],
            "Dark Heather": ["XS","S","M","L","XL"],
            "Black": ["XS","S","M","L","XL"],
  
            "Heather Orange": ["XS","S","M","L","XL"],
            "Heather Military Green": ["XS","S","M","L","XL"],
            "Heather Purple": ["XS","S","M","L","XL"],
            "Heather Galapagos Blue": ["XS","S","M","L","XL"],
  
            "Sand": ["XS","S","M","L","XL"],
            "Daisy": ["XS","S","M","L","XL"],
            "Orange": ["XS","S","M","L","XL"],
            "Light Pink": ["XS","S","M","L","XL"],
            "Red": ["XS","S","M","L","XL"],
            "Heather Red": ["XS","S","M","L","XL"],
            "Maroon": ["XS","S","M","L","XL"],
  
            "Heather Irish Green": ["XS","S","M","L","XL"],
            "Military Green": ["XS","S","M","L","XL"],
            "Irish Green": ["XS","S","M","L","XL"],
  
            "Light Blue": ["XS","S","M","L","XL"],
            "Heather Royal": ["XS","S","M","L","XL"],
            "Indigo Blue": ["XS","S","M","L","XL"],
            "Sapphire": ["XS","S","M","L","XL"],
            "Royal": ["XS","S","M","L","XL"],
            "Heather Navy": ["XS","S","M","L","XL"],
            "Navy": ["XS","S","M","L","XL"],
            "Purple": ["XS","S","M","L","XL"]
          }
        }
      },
  
      "Long Sleeve": {
        "G540B": {
          colors: {
            "White": ["XS","S","M","L","XL"],
            "Sport Gray": ["XS","S","M","L","XL"],
            "Black": ["XS","S","M","L","XL"],
            "Gold": ["XS","S","M","L","XL"],
            "Red": ["XS","S","M","L","XL"],
            "Irish Green": ["XS","S","M","L","XL"],
            "Forest Green": ["XS","S","M","L","XL"],
            "Carolina Blue": ["XS","S","M","L","XL"],
            "Royal": ["XS","S","M","L","XL"],
            "Navy": ["XS","S","M","L","XL"],
            "Purple": ["XS","S","M","L","XL"]
          }
        }
      },
  
      "Sweatshirt": {
        "G180B": {
          colors: {
            "White": ["XS","S","M","L","XL"],
            "Sport Gray": ["XS","S","M","L","XL"],
            "Dark Heather": ["XS","S","M","L","XL"],
            "Black": ["XS","S","M","L","XL"],
            "Safety Pink": ["XS","S","M","L","XL"],
            "Maroon": ["XS","S","M","L","XL"],
            "Red": ["XS","S","M","L","XL"],
            "Forest Green": ["XS","S","M","L","XL"],
            "Royal": ["XS","S","M","L","XL"],
            "Navy": ["XS","S","M","L","XL"]
          }
        }
      },
  
      "Hoodie": {
        "G185B": {
          colors: {
            "White": ["XS","S","M","L","XL"],
            "Sport Gray": ["XS","S","M","L","XL"],
            "Charcoal": ["XS","S","M","L","XL"],
            "Graphite Heather": ["XS","S","M","L","XL"],
            "Dark Heather": ["XS","S","M","L","XL"],
            "Black": ["XS","S","M","L","XL"],
            "Fan Charcoal Heather": ["XS","S","M","L","XL"],
            "Gold": ["XS","S","M","L","XL"],
            "Orange": ["XS","S","M","L","XL"],
            "Light Pink": ["XS","S","M","L","XL"],
            "Heliconia": ["XS","S","M","L","XL"],
            "Maroon": ["XS","S","M","L","XL"],
            "Red": ["XS","S","M","L","XL"],
            "Fan Dark Green": ["XS","S","M","L","XL"],
            "Irish Green": ["XS","S","M","L","XL"],
            "Forest": ["XS","S","M","L","XL"],
            "Carolina Blue": ["XS","S","M","L","XL"],
            "Royal": ["XS","S","M","L","XL"],
            "Navy": ["XS","S","M","L","XL"],
            "Purple": ["XS","S","M","L","XL"],
            "Sand": ["XS","S","M","L","XL"]
          }
        }
      }
    }
  },

  Adult: {
    GL: {
      "Short Sleeve": {
        G640: {
          colors: {
            "White": ["XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL", "5XL"],
            "Off White": ["S", "M", "L", "XL", "2XL", "3XL", "4XL", "5XL"],
            "Natural": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Ice Gray": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Sport Gray": ["XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL", "5XL"],
  
            "Charcoal": ["XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL", "5XL"],
            "Graphite Heather": ["XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL"],
            "Dark Heather": ["XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL", "5XL"],
            "Heather Dark Grey": ["XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL", "5XL"],
            "Black": ["XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL", "5XL"],
  
            "Heather Oatmeal": ["S", "M", "L", "XL", "2XL", "3XL", "4XL"],
            "Cornsilk": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Daisy": ["S", "M", "L", "XL", "2XL", "3XL", "4XL"],
            "Gold": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Heather Orange": ["S", "M", "L", "XL", "2XL", "3XL", "4XL"],
  
            "Orange": ["S", "M", "L", "XL", "2XL", "3XL", "4XL"],
            "Fan Texas Orange": ["S", "M", "L", "XL", "2XL", "3XL", "4XL"],
  
            "Light Pink": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Azalea": ["XS", "S", "M", "L", "XL", "2XL", "3XL"],
            "Coral Silk": ["S", "M", "L", "XL", "2XL", "3XL"],
  
            "Heather Heliconia": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Heliconia": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Antique Heliconia": ["S", "M", "L", "XL", "2XL", "3XL"],
  
            "Heather Maroon": ["S", "M", "L", "XL", "2XL", "3XL", "4XL"],
            "Heather Red": ["XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL"],
            "Antique Cherry Red": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Cherry Red": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Heather Cardinal": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Red": ["XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL", "5XL"],
            "Maroon": ["S", "M", "L", "XL", "2XL", "3XL", "4XL"],
  
            "Garnet": ["S", "M", "L", "XL", "2XL", "3XL", "4XL"],
            "Cardinal": ["S", "M", "L", "XL", "2XL", "3XL", "4XL"],
            "Pistachio": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Mint Green": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Sage": ["S", "M", "L", "XL", "2XL", "3XL"],
  
            "Lime": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Heather Military Green": ["S", "M", "L", "XL", "2XL", "3XL", "4XL"],
            "Heather Irish Green": ["S", "M", "L", "XL", "2XL", "3XL", "4XL"],
            "Kiwi": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Military Green": ["XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL"],
  
            "Kelly Green": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Jade Dome": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Turf Green": ["S", "M", "L", "XL", "2XL", "3XL", "4XL"],
            "Irish Green": ["S", "M", "L", "XL", "2XL", "3XL", "4XL"],
            "Forest Green": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Fan Marine Green": ["S", "M", "L", "XL", "2XL", "3XL", "4XL"],
  
            "Sky": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Light Blue": ["S", "M", "L", "XL", "2XL", "3XL", "4XL"],
            "Iris": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Carolina Blue": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Stone Blue": ["S", "M", "L", "XL", "2XL", "3XL"],
  
            "Antique Sapphire": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Heather Indigo": ["S", "M", "L", "XL", "2XL", "3XL", "4XL"],
            "Sapphire": ["S", "M", "L", "XL", "2XL", "3XL", "4XL"],
            "Indigo": ["S", "M", "L", "XL", "2XL", "3XL", "4XL"],
            "Heather Galapagos Blue": ["S", "M", "L", "XL", "2XL", "3XL"],
  
            "Neon Blue": ["S", "M", "L", "XL", "2XL", "3XL", "4XL"],
            "Metro Blue": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Heather Sapphire": ["XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL"],
            "Tropical Blue": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Heather Royal": ["XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL", "5XL"],
  
            "Royal": ["XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL", "5XL"],
            "Fan Deep Royal": ["S", "M", "L", "XL", "2XL", "3XL", "4XL"],
            "Navy": ["XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL", "5XL"],
            "Heather Navy": ["XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL", "5XL"],
            "Paragon": ["S", "M", "L", "XL", "2XL", "3XL"],
  
            "Heather Berry": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Heather Radiant Orchid": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Heather Purple": ["S", "M", "L", "XL", "2XL", "3XL", "4XL"],
            "Purple": ["S", "M", "L", "XL", "2XL", "3XL", "4XL"],
            "Sand": ["XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL"],
            "Dark Chocolate": ["S", "M", "L", "XL", "2XL", "3XL"]
          }
        }
      },
  
      "Hoodie": {
        SF500: {
          colors: {
            "White": ["XS","S","M","L","XL","2XL","3XL","4XL","5XL"],
            "Off White": ["S","M","L","XL","2XL","3XL","4XL","5XL"],
            "Ash Grey": ["S","M","L","XL","2XL","3XL","4XL","5XL"],
            "Cement": ["S","M","L","XL","2XL","3XL","4XL"],
            "Ring Spun Sport Gray": ["S","M","L","XL","2XL","3XL","4XL","5XL"],
  
            "Charcoal": ["S","M","L","XL","2XL","3XL","4XL"],
            "Smoke": ["S","M","L","XL","2XL","3XL","4XL"],
            "Dark Heather": ["S","M","L","XL","2XL","3XL","4XL","5XL"],
            "Heather Black": ["S","M","L","XL","2XL","3XL","4XL"],
            "Black": ["S","M","L","XL","2XL","3XL","4XL","5XL"],
  
            "Sand": ["S","M","L","XL","2XL","3XL","4XL"],
            "Yellow Haze": ["S","M","L","XL","2XL","3XL","4XL"],
            "Daisy": ["S","M","L","XL","2XL","3XL","4XL"],
            "Mustard": ["S","M","L","XL","2XL","3XL","4XL"],
            "Dusty Rose": ["S","M","L","XL","2XL","3XL","4XL"],
  
            "Tangerine": ["S","M","L","XL","2XL","3XL","4XL"],
            "Texas Orange": ["S","M","L","XL","2XL","3XL","4XL"],
            "Light Pink": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Pink Lemonade": ["S","M","L","XL","2XL","3XL","4XL"],
            "Red": ["S","M","L","XL","2XL","3XL","4XL","5XL"],
  
            "Cardinal": ["S","M","L","XL","2XL","3XL","4XL"],
            "Maroon": ["S","M","L","XL","2XL","3XL","4XL"],
            "Pistachio": ["S","M","L","XL","2XL","3XL","4XL"],
            "Sage": ["S","M","L","XL","2XL","3XL","4XL"],
            "Military Green": ["S","M","L","XL","2XL","3XL","4XL"],
  
            "Forest Green": ["S","M","L","XL","2XL","3XL","4XL"],
            "Sky": ["S","M","L","XL","2XL","3XL","4XL"],
            "Carolina Blue": ["S","M","L","XL","2XL","3XL","4XL"],
            "Stone Blue": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Aquatic": ["S","M","L","XL","2XL","3XL","4XL"],
  
            "Cobalt": ["S","M","L","XL","2XL","3XL","4XL"],
            "Blue Dusk": ["S","M","L","XL","2XL","3XL","4XL"],
            "Royal": ["S","M","L","XL","2XL","3XL","4XL"],
            "Navy": ["S","M","L","XL","2XL","3XL","4XL","5XL"],
            "Paragon": ["S","M","L","XL","2XL","3XL","4XL"],
  
            "Purple": ["S","M","L","XL","2XL","3XL","4XL"],
            "Brown Savana": ["S","M","L","XL","2XL","3XL","4XL"],
            "Cocoa": ["S","M","L","XL","2XL","3XL","4XL"]
          }
        }
      },
  
      "Long Sleeve": {
        G540: {
          colors: {
            "White": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Ash": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Sport Gray": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Charcoal": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Graphite Heather": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Dark Heather": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Black": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Gold": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Orange": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Safety Orange": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Light Pink": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Cardinal Red": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Red": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Maroon": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Irish Green": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Safety Green": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Military Green": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Forest Green": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Light Blue": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Carolina Blue": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Indigo Blue": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Royal": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Navy": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Purple": ["S", "M", "L", "XL", "2XL", "3XL"]
          }
        }
      },
  
      "Sweatshirt": {
        G180: {
          colors: {
            "White": ["XS","S","M","L","XL","2XL","3XL","4XL","5XL"],
            "Ash": ["XS","S","M","L","XL","2XL","3XL","4XL","5XL"],
            "Graphite Heather": ["S","M","L","XL","2XL","3XL","4XL","5XL"],
            "Sport Gray": ["XS","S","M","L","XL","2XL","3XL","4XL","5XL"],
  
            "Charcoal": ["S","M","L","XL","2XL","3XL","4XL","5XL"],
            "Dark Heather": ["XS","S","M","L","XL","2XL","3XL","4XL","5XL"],
            "Black": ["XS","S","M","L","XL","2XL","3XL","4XL","5XL"],
            "Fan Heather Charcoal": ["S","M","L","XL","2XL","3XL","4XL"],
  
            "Gold": ["S","M","L","XL","2XL","3XL","4XL","5XL"],
            "Orange": ["S","M","L","XL","2XL","3XL","4XL","5XL"],
            "Light Pink": ["XS","S","M","L","XL","2XL","3XL","4XL","5XL"],
            "Safety Pink": ["S","M","L","XL","2XL","3XL","4XL","5XL"],
            "Heliconia": ["XS","S","M","L","XL","2XL","3XL","4XL","5XL"],
  
            "Cardinal Red": ["S","M","L","XL","2XL","3XL","4XL","5XL"],
            "Heather Sport Scarlet Red": ["S","M","L","XL","2XL","3XL","4XL","5XL"],
            "Maroon": ["S","M","L","XL","2XL","3XL","4XL","5XL"],
            "Red": ["XS","S","M","L","XL","2XL","3XL","4XL","5XL"],
            "Cherry Red": ["S","M","L","XL","2XL","3XL","4XL","5XL"],
  
            "Heather Sport Dark Maroon": ["S","M","L","XL","2XL","3XL","4XL","5XL"],
            "Garnet": ["S","M","L","XL","2XL","3XL","4XL","5XL"],
            "High Viz Safety Green": ["S","M","L","XL","2XL","3XL","4XL","5XL"],
            "Military Green": ["S","M","L","XL","2XL","3XL","4XL","5XL"],
  
            "Heather Sport Dark Green": ["S","M","L","XL","2XL","3XL","4XL","5XL"],
            "Fan Dark Green": ["S","M","L","XL","2XL","3XL","4XL"],
            "Irish Green": ["S","M","L","XL","2XL","3XL","4XL","5XL"],
            "Forest Green": ["S","M","L","XL","2XL","3XL","4XL","5XL"],
  
            "Light Blue": ["S","M","L","XL","2XL","3XL","4XL","5XL"],
            "Carolina Blue": ["S","M","L","XL","2XL","3XL","4XL","5XL"],
            "Sapphire": ["S","M","L","XL","2XL","3XL","4XL","5XL"],
            "Indigo Blue": ["S","M","L","XL","2XL","3XL","4XL","5XL"],
            "Neon Blue": ["S","M","L","XL","2XL","3XL","4XL"],
  
            "Royal": ["XS","S","M","L","XL","2XL","3XL","4XL","5XL"],
            "Heather Deep Royal": ["S","M","L","XL","2XL","3XL","4XL","5XL"],
            "Fan Deep Royal": ["S","M","L","XL","2XL","3XL","4XL"],
            "Navy": ["XS","S","M","L","XL","2XL","3XL","4XL","5XL"],
  
            "Purple": ["S","M","L","XL","2XL","3XL","4XL","5XL"],
            "Sand": ["XS","S","M","L","XL","2XL","3XL","4XL","5XL"],
            "Dark Chocolate": ["S","M","L","XL","2XL","3XL","4XL","5XL"]
          }
        }
      }
    },
  
    BC: {
      "Cropped Hoodie": {
        B7502: {
          colors: {
            Peach: ["S", "M", "L", "XL", "2XL"]
          }
        }
      },
  
      "Short Sleeve": {
        "3001C": {
          colors: {
            "White": ["XS","S","M","L","XL","2XL","3XL","4XL","5XL"],
            "Natural": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Vintage White": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Ash": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Silver": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Athletic Heather": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Heather Dust": ["XS","S","M","L","XL","2XL","3XL","4XL"],
  
            "Storm": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Dark Gray": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Asphalt": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Slate": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Heather Slate": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Black": ["XS","S","M","L","XL","2XL","3XL","4XL","5XL"],
            "Vintage Black": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Heather Black": ["XS","S","M","L","XL","2XL","3XL","4XL","5XL"],
  
            "Yellow": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Maize Yellow": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Mustard": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Gold": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Sunset": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Peach": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Heather Peach": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Terracotta": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Coral": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Orange": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Heather Orange": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Autumn": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Heather Autumn": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Burnt Orange": ["XS","S","M","L","XL","2XL","3XL","4XL"],
  
            "Soft Pink": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Lilac": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Pink": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Orchid": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Charity Pink": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Fuchsia": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Mauve": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Heather Mauve": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Heather Prism Peach": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Heather Prism Lilac": ["XS","S","M","L","XL","2XL","3XL","4XL"],
  
            "Berry": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Vintage Red": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Poppy": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Canvas Red": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Red": ["XS","S","M","L","XL","2XL","3XL","4XL","5XL"],
            "Heather Red": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Cardinal": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Heather Cardinal": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Rust": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Maroon": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Heather Maroon": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Oxblood": ["XS","S","M","L","XL","2XL","3XL","4XL"],
  
            "Mint": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Heather Mint": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Citron": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Spring Green": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Thyme": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Sage": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Heather Sage": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Army": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Pine": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Teal": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Olive": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Leaf": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Kelly": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Heather Green": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Heather Kelly": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Military Green": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Heather Military Green": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Forest": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Heather Forest": ["XS","S","M","L","XL","2XL","3XL","4XL"],
  
            "Atlantic": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Vintage Denim": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Light Blue": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Baby Blue": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Carolina Blue": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Dusty Blue": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Ocean Blue": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Aqua": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Columbia Blue": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Heather Columbia Blue": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Steel Blue": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Turquoise": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Electric Blue": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Deep Teal": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Heather Deep Teal": ["XS","S","M","L","XL","2XL","3XL","4XL","5XL"],
            "Marine": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Cool Blue": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Navy": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Heather Navy": ["XS","S","M","L","XL","2XL","3XL","4XL","5XL"],
            "True Royal": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Heather True Royal": ["XS","S","M","L","XL","2XL","3XL","4XL"],
  
            "Lavender Dust": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Dark Lavender": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Light Violet": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Royal Purple": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Purple Storm": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Team Purple": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Heather Purple": ["XS","S","M","L","XL","2XL","3XL","4XL"],
  
            "Soft Cream": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Sand Dune": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Tan": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Chestnut": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Toast": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Clay": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Pebble": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Vintage Brown": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Cocoa": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Brown": ["XS","S","M","L","XL","2XL","3XL","4XL"]
          }
        }
      },
  
      "Cropped Short Sleeve": {
        "6482": {
          colors: {
            "White": ["XS","S","M","L","XL","2XL"],
            "Vintage White": ["XS","S","M","L","XL","2XL"],
            "Heather Athletic": ["XS","S","M","L","XL","2XL"],
            "Black": ["XS","S","M","L","XL","2XL"],
            "Mustard": ["XS","S","M","L","XL","2XL"],
            "Military Green": ["XS","S","M","L","XL","2XL"]
          }
        }
      },
  
      "Long Sleeve": {
        "3501": {
          colors: (() => {
            const colors = {};
  
            const allColors = [
              "White","Natural","Ash","Silver",
              "Storm","Dark Gray","Asphalt","Charcoal Black Slub","Solid Black Slub",
              "Vintage Black","Black","Soft Cream","Gold","Mustard",
              "Orange","Pink","Mauve","Berry","Poppy","Red","Cardinal","Maroon","Canvas Red",
              "Citron","Mint","Strobe","Teal","Olive","Military Green",
              "Forest","Kelly","Baby Blue","Carolina Blue","Lavender Blue",
              "Blue Storm","Steel Blue","Atlantic","True Royal","Vintage Navy","Navy",
              "Light Violet","Dark Lavender","Team Purple","Sand Dune","Terracotta",
              "Chestnut","Toast","Vintage Brown",
  
              "Solid White Blend","Heather Natural","Heather Athletic","Heather Dark Gray",
              "Heather Deep","Heather Black","Solid Black Blend","Heather French Vanilla",
              "Heather Mustard","Heather Yellow Gold","Heather Peach","Heather Mauve",
              "Heather Pink Gravel","Heather Clay","Heather Red","Heather Maroon",
              "Heather Cardinal","Heather Stone","Heather Forest","Heather Olive",
              "Heather Military Green","Heather Carolina Blue","Heather Columbia Blue",
              "Heather Dusty Blue","Heather Deep Teal","Heather Slate",
              "Heather True Royal","Heather Navy","Heather Midnight Navy",
              "Heather Dark Lavnder","Heather Brown",
  
              "Solid White Triblend","Oatmeal Triblend","Athletic Gray Triblend","Gray Triblend",
              "Solid Dark Gray Triblend","Charcoal Black Triblend","Solid Black Triblend",
              "Heather Black Triblend","Mauve Triblend","Brick Triblend","Red Triblend",
              "Maroon Triblend","Olive Triblend","Emerald Triblend","Blue Triblend",
              "Denim Triblend","True Royal Triblend","Navy Triblend","Solid Navy Triblend"
            ];
  
            const up4xl = ["White","Black","Heather Athletic","Heather Dark Gray"];
  
            const down2xl = [
              "Athletic Gray Triblend",
              "Solid Black Triblend",
              "Emerald Triblend",
              "Denim Triblend",
              "Brick Triblend"
            ];
  
            allColors.forEach(color => {
              if (down2xl.includes(color)) {
                colors[color] = LS_DOWN_2XL;
              } else if (up4xl.includes(color)) {
                colors[color] = LS_UP_4XL;
              } else {
                colors[color] = LS_BASE;
              }
            });
  
            return colors;
          })()
        }
      },

      "Sweatshirt": {
        "3901": {
          colors: {
            "White": ["XS","S","M","L","XL","2XL","3XL"],
            "Natural": ["XS","S","M","L","XL","2XL","3XL"],
            "Heather Dust": ["XS","S","M","L","XL","2XL","3XL"],
            "Ash": ["XS","S","M","L","XL","2XL","3XL"],
            "Heather Athletic": ["XS","S","M","L","XL","2XL","3XL"],
            "Gray Acid Fleece": ["XS","S","M","L","XL","2XL","3XL"],
            "Gray Triblend": ["XS","S","M","L","XL","2XL"],
            "Heather Deep": ["XS","S","M","L","XL","2XL","3XL"],
            "Heather Dark Gray": ["XS","S","M","L","XL","2XL","3XL"],
            "Silver": ["XS","S","M","L","XL","2XL","3XL"],
            "Asphalt": ["XS","S","M","L","XL","2XL","3XL"],
            "Heather Black": ["XS","S","M","L","XL","2XL","3XL"],
            "Black": ["XS","S","M","L","XL","2XL","3XL"],
            "Vintage Black": ["XS","S","M","L","XL","2XL","3XL"],
            "Heather Mustard": ["XS","S","M","L","XL","2XL","3XL"],
            "Mauve": ["XS","S","M","L","XL","2XL","3XL"],
            "Pink": ["XS","S","M","L","XL","2XL","3XL"],
            "Red": ["XS","S","M","L","XL","2XL","3XL"],
            "Maroon": ["XS","S","M","L","XL","2XL","3XL"],
            "Cardinal": ["XS","S","M","L","XL","2XL","3XL"],
            "Heather Red": ["XS","S","M","L","XL","2XL","3XL"],
            "Heather Forest": ["XS","S","M","L","XL","2XL","3XL"],
            "Forest": ["XS","S","M","L","XL","2XL","3XL"],
            "Heather Olive": ["XS","S","M","L","XL","2XL","3XL"],
            "Military Green": ["XS","S","M","L","XL","2XL","3XL"],
            "Heather Deep Teal": ["XS","S","M","L","XL","2XL","3XL"],
            "Lavender Blue": ["XS","S","M","L","XL","2XL","3XL"],
            "Heather Blue Lagoon": ["XS","S","M","L","XL","2XL","3XL"],
            "Blue Storm": ["XS","S","M","L","XL","2XL","3XL"],
            "Carolina Blue": ["XS","S","M","L","XL","2XL","3XL"],
            "Heather True Royal": ["XS","S","M","L","XL","2XL","3XL"],
            "True Royal": ["XS","S","M","L","XL","2XL","3XL"],
            "Navy": ["XS","S","M","L","XL","2XL","3XL"],
            "Heather Navy": ["XS","S","M","L","XL","2XL","3XL"],
            "Team Purple": ["XS","S","M","L","XL","2XL","3XL"],

            // "Light Gray Marble": ["XS","S","M","L","XL","2XL"],
            // "Dark Gray Marble Fleece": ["XS","S","M","L","XL","2XL"],
            // "Dark Gray": ["XS","S","M","L","XL","2XL","3XL"],
            // "Heather Deep / Black": ["XS","S","M","L","XL","2XL"],
            // "Heather Deep / Navy": ["XS","S","M","L","XL","2XL"],
            // "French Vanilla": ["XS","S","M","L","XL","2XL","3XL"],
            // "Gold": ["XS","S","M","L","XL","2XL","3XL"],
            // "Peach": ["XS","S","M","L","XL","2XL","3XL"],
            // "Brick": ["XS","S","M","L","XL","2XL","3XL"],
            // "Autumn": ["XS","S","M","L","XL","2XL","3XL"],
            // "Red Marble Fleck": ["XS","S","M","L","XL","2XL"],
            // "Cardinal Triblend": ["XS","S","M","L","XL","2XL"],
            // "Navy Triblend": ["XS","S","M","L","XL","2XL"]
          }
        }
      },

      "Hoodie": {
        "3719": {
          colors: (() => {
            const colors = {};

            const base = ["XS","S","M","L","XL","2XL","3XL"];
            const up4xl = ["XS","S","M","L","XL","2XL","3XL","4XL"];
            const down2xl = ["XS","S","M","L","XL","2XL"];

            const allColors = [
              "White","Vintage White","Natural",
              "Ash","Storm","Heather Athletic","Heather Deep","Heather Dark Gray","Dark Gray",
              "Asphalt","Silver","Heather Black","Black","Vintage Black","Heather Dust",
              "Heather Mustard",
              "Orange","Heather Charity Pink","Mauve","Pink",
              "Heather Red","Red","Heather Maroon","Maroon","Cardinal",
              "Teal","Heather Forest","Military Green","Forest","Kelly","Heather Olive",
              "Lavender Blue","Dusty Blue","Heather Blue Lagoon","Blue Storm",
              "Heather Deep Teal","Heather Slate","Atlantic","Heather Columbia Blue",
              "Steel Blue","Carolina Blue",
              "Heather True Royal","True Royal","Heather Navy","Navy",
              "Dark Lavender","Team Purple","Heather Team Purple",
              "Tan","Vintage Brown"
            ];

            const up4xlColors = ["Black","Heather Dark Gray","Heather Athletic"];
            const down2xlColors = ["Mauve","Pink","Heather Charity Pink"];

            allColors.forEach(color => {
              if (down2xlColors.includes(color)) {
                colors[color] = down2xl;
              } else if (up4xlColors.includes(color)) {
                colors[color] = up4xl;
              } else {
                colors[color] = base;
              }
            });

            return colors;
          })()
        }
      },

      "Cropped Hoodie": {
        "B7502": {
          colors: {
            "White": ["S","M","L","XL","2XL"],
            "Heather Dust": ["S","M","L","XL","2XL"],
            "Storm": ["S","M","L","XL","2XL"],
            "Heather Dark Gray": ["S","M","L","XL","2XL"],
            "Black": ["S","M","L","XL","2XL"],
            "Military Green": ["S","M","L","XL","2XL"]

            // "Heather Deep": ["S","M","L","XL","2XL"],
            // "Heather Mustard": ["S","M","L","XL","2XL"],
            // "Peach": ["S","M","L","XL","2XL"],
            // "Pink": ["S","M","L","XL","2XL"],
            // "Mauve": ["S","M","L","XL","2XL"],
            // "Atlantic": ["S","M","L","XL","2XL"],
            // "Navy": ["S","M","L","XL","2XL"],
            // "Team Purple": ["S","M","L","XL","2XL"]
          }
        }
      }
    },
  
    CC: {
      "Short Sleeve": {
        "CC1745": {
          colors: {
            "Smoke": ["S","M","L","XL","2XL","3XL"],
            "Citrine": ["S","M","L","XL","2XL","3XL"],
            "Umber": ["S","M","L","XL","2XL","3XL"],
            "Hibiscus": ["S","M","L","XL","2XL","3XL"],
            "Clay": ["S","M","L","XL","2XL","3XL"],
            "Sea Glass": ["S","M","L","XL","2XL","3XL"],
            "Fern": ["S","M","L","XL","2XL","3XL"],
            "Fiji Blue": ["S","M","L","XL","2XL","3XL"],
            "Ocean": ["S","M","L","XL","2XL","3XL"],
            "Amethyst": ["S","M","L","XL","2XL","3XL"]
          }
        },
    
        "C1717": {
          colors: (() => {
            const base = ["S","M","L","XL","2XL","3XL","4XL"];
            const colors = {};
    
            const allColors = [
              "White","Gray","Granite","Graphite","Pepper","Black",
              "Sandstone","Khaki","Butter","Neon Lemon","Citrus","Mustard",
              "Peachy","Neon Red Orange","Neon Cantaloupe","Bright Salmon",
              "Terracotta","Melon","Bright Orange","Burnt Orange","Yam",
              "Blossom","Neon Pink","Crunchberry","Watermelon","Red","Paprika",
              "Crimson","Berry","Chili","Brick","Island Reef","Bay",
              "Chalky Mint","Moss","Seafoam","Island Green","Sage",
              "Blue Spruce","Light Green","Hemp","Emerald",
              "Washed Denim","Denim","Chambray","Hydrangea","Lagoon Blue",
              "Flo Blue","Sapphire","Mystic Blue","Ice Blue","Periwinkle",
              "Blue Jean","China Blue","Midnight","Royal Caribe","Dusk",
              "True Navy","Navy","Orchid","Neon Violet","Violet","Grape",
              "Wine","Espresso","Rose Quartz","Ivory"
            ];
    
            allColors.forEach(c => colors[c] = base);
            return colors;
          })()
        }
      },
    
      "Long Sleeve": {
        "C6014": {
          colors: (() => {
            const base = ["S","M","L","XL","2XL","3XL","4XL"];
            const up3xl = ["S","M","L","XL","2XL","3XL"];
            const up2xl = ["S","M","L","XL","2XL"];
    
            const colors = {};
    
            const allColors = [
              "White","Ivory","Gray","Granite","Graphite","Pepper","Black",
              "Khaki","Butter","Mustard","Neon Yellow","Peachy","Melon",
              "Bright Salmon","Terracotta","Neon Red Orange","Burnt Orange","Mango",
              "Blossom","Watermelon","Neon Pink",
              "Heliconia","Red","Brick",
              "Crimson",
              "Island Reef",
              "Chalky Mint","Light Green","Seafoam","Island Green","Blue Spruce",
              "Hemp","Washed Denim","Denim","Hydrangea","Chambray","Lagoon Blue","Ice Blue","Flo Blue",
              "China Blue","Midnight","Blue Jean","Royal Caribe","True Navy","Navy",
              "Orchid","Violet","Berry","Grape",
              "Espresso"
            ];
    
            const limit3xl = ["Peachy","Melon","Hydrangea","Espresso"];
            const limit2xl = ["Neon Yellow"];
    
            allColors.forEach(color => {
              if (limit2xl.includes(color)) {
                colors[color] = up2xl;
              } else if (limit3xl.includes(color)) {
                colors[color] = up3xl;
              } else {
                colors[color] = base;
              }
            });
    
            return colors;
          })()
        }
      },
    
      "Sweatshirt": {
        "1566": {
          colors: {
            "White": ["S","M","L","XL","2XL","3XL"],
            "Gray": ["S","M","L","XL","2XL","3XL"],
            "Pepper": ["S","M","L","XL","2XL","3XL"],
            "Butter": ["S","M","L","XL","2XL","3XL"],
            "Terracotta": ["S","M","L","XL","2XL","3XL"],
            "Watermelon": ["S","M","L","XL","2XL","3XL"],
            "Crimson": ["S","M","L","XL","2XL","3XL"],
            "Seafoam": ["S","M","L","XL","2XL","3XL"],
            "Chalky Mint": ["S","M","L","XL","2XL","3XL"],
            "Light Green": ["S","M","L","XL","2XL","3XL"],
            "Blue Spruce": ["S","M","L","XL","2XL","3XL"],
            "Denim": ["S","M","L","XL","2XL","3XL"],
            "Chambray": ["S","M","L","XL","2XL","3XL"],
            "Flo Blue": ["S","M","L","XL","2XL","3XL"],
            "Blue Jean": ["S","M","L","XL","2XL","3XL"],
            "True Navy": ["S","M","L","XL","2XL","3XL"],
            "Orchid": ["S","M","L","XL","2XL","3XL"],
            "Violet": ["S","M","L","XL","2XL","3XL"]
          }
        }
      },
    
      "Hoodie": {
        "1567": {
          colors: {
            "White": ["S","M","L","XL","2XL","3XL"],
            "Gray": ["S","M","L","XL","2XL","3XL"],
            "Pepper": ["S","M","L","XL","2XL","3XL"],
            "Crimson": ["S","M","L","XL","2XL","3XL"],
            "Seafoam": ["S","M","L","XL","2XL","3XL"],
            "Light Green": ["S","M","L","XL","2XL","3XL"],
            "Blue Spruce": ["S","M","L","XL","2XL","3XL"],
            "Denim": ["S","M","L","XL","2XL","3XL"],
            "Flo Blue": ["S","M","L","XL","2XL","3XL"],
            "Blue Jean": ["S","M","L","XL","2XL","3XL"],
            "True Navy": ["S","M","L","XL","2XL","3XL"]
    
            // "Lagoon Blue": ["S","M","L","XL","2XL","3XL"]
          }
        }
      }
    }
  }
};

window.APPAREL_RULES_ADULT = {
  Adult: {
    GL: {
      "Short Sleeve": {
        G640: {
          colors: {
            "White": ["XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL", "5XL"],
            "Off White": ["S", "M", "L", "XL", "2XL", "3XL", "4XL", "5XL"],
            "Natural": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Ice Gray": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Sport Gray": ["XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL", "5XL"],
  
            "Charcoal": ["XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL", "5XL"],
            "Graphite Heather": ["XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL"],
            "Dark Heather": ["XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL", "5XL"],
            "Heather Dark Grey": ["XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL", "5XL"],
            "Black": ["XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL", "5XL"],
  
            "Heather Oatmeal": ["S", "M", "L", "XL", "2XL", "3XL", "4XL"],
            "Cornsilk": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Daisy": ["S", "M", "L", "XL", "2XL", "3XL", "4XL"],
            "Gold": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Heather Orange": ["S", "M", "L", "XL", "2XL", "3XL", "4XL"],
  
            "Orange": ["S", "M", "L", "XL", "2XL", "3XL", "4XL"],
            "Fan Texas Orange": ["S", "M", "L", "XL", "2XL", "3XL", "4XL"],
  
            "Light Pink": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Azalea": ["XS", "S", "M", "L", "XL", "2XL", "3XL"],
            "Coral Silk": ["S", "M", "L", "XL", "2XL", "3XL"],
  
            "Heather Heliconia": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Heliconia": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Antique Heliconia": ["S", "M", "L", "XL", "2XL", "3XL"],
  
            "Heather Maroon": ["S", "M", "L", "XL", "2XL", "3XL", "4XL"],
            "Heather Red": ["XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL"],
            "Antique Cherry Red": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Cherry Red": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Heather Cardinal": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Red": ["XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL", "5XL"],
            "Maroon": ["S", "M", "L", "XL", "2XL", "3XL", "4XL"],
  
            "Garnet": ["S", "M", "L", "XL", "2XL", "3XL", "4XL"],
            "Cardinal": ["S", "M", "L", "XL", "2XL", "3XL", "4XL"],
            "Pistachio": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Mint Green": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Sage": ["S", "M", "L", "XL", "2XL", "3XL"],
  
            "Lime": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Heather Military Green": ["S", "M", "L", "XL", "2XL", "3XL", "4XL"],
            "Heather Irish Green": ["S", "M", "L", "XL", "2XL", "3XL", "4XL"],
            "Kiwi": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Military Green": ["XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL"],
  
            "Kelly Green": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Jade Dome": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Turf Green": ["S", "M", "L", "XL", "2XL", "3XL", "4XL"],
            "Irish Green": ["S", "M", "L", "XL", "2XL", "3XL", "4XL"],
            "Forest Green": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Fan Marine Green": ["S", "M", "L", "XL", "2XL", "3XL", "4XL"],
  
            "Sky": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Light Blue": ["S", "M", "L", "XL", "2XL", "3XL", "4XL"],
            "Iris": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Carolina Blue": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Stone Blue": ["S", "M", "L", "XL", "2XL", "3XL"],
  
            "Antique Sapphire": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Heather Indigo": ["S", "M", "L", "XL", "2XL", "3XL", "4XL"],
            "Sapphire": ["S", "M", "L", "XL", "2XL", "3XL", "4XL"],
            "Indigo": ["S", "M", "L", "XL", "2XL", "3XL", "4XL"],
            "Heather Galapagos Blue": ["S", "M", "L", "XL", "2XL", "3XL"],
  
            "Neon Blue": ["S", "M", "L", "XL", "2XL", "3XL", "4XL"],
            "Metro Blue": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Heather Sapphire": ["XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL"],
            "Tropical Blue": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Heather Royal": ["XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL", "5XL"],
  
            "Royal": ["XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL", "5XL"],
            "Fan Deep Royal": ["S", "M", "L", "XL", "2XL", "3XL", "4XL"],
            "Navy": ["XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL", "5XL"],
            "Heather Navy": ["XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL", "5XL"],
            "Paragon": ["S", "M", "L", "XL", "2XL", "3XL"],
  
            "Heather Berry": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Heather Radiant Orchid": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Heather Purple": ["S", "M", "L", "XL", "2XL", "3XL", "4XL"],
            "Purple": ["S", "M", "L", "XL", "2XL", "3XL", "4XL"],
            "Sand": ["XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL"],
            "Dark Chocolate": ["S", "M", "L", "XL", "2XL", "3XL"]
          }
        }
      },
  
      "Hoodie": {
        SF500: {
          colors: {
            "White": ["XS","S","M","L","XL","2XL","3XL","4XL","5XL"],
            "Off White": ["S","M","L","XL","2XL","3XL","4XL","5XL"],
            "Ash Grey": ["S","M","L","XL","2XL","3XL","4XL","5XL"],
            "Cement": ["S","M","L","XL","2XL","3XL","4XL"],
            "Ring Spun Sport Gray": ["S","M","L","XL","2XL","3XL","4XL","5XL"],
  
            "Charcoal": ["S","M","L","XL","2XL","3XL","4XL"],
            "Smoke": ["S","M","L","XL","2XL","3XL","4XL"],
            "Dark Heather": ["S","M","L","XL","2XL","3XL","4XL","5XL"],
            "Heather Black": ["S","M","L","XL","2XL","3XL","4XL"],
            "Black": ["S","M","L","XL","2XL","3XL","4XL","5XL"],
  
            "Sand": ["S","M","L","XL","2XL","3XL","4XL"],
            "Yellow Haze": ["S","M","L","XL","2XL","3XL","4XL"],
            "Daisy": ["S","M","L","XL","2XL","3XL","4XL"],
            "Mustard": ["S","M","L","XL","2XL","3XL","4XL"],
            "Dusty Rose": ["S","M","L","XL","2XL","3XL","4XL"],
  
            "Tangerine": ["S","M","L","XL","2XL","3XL","4XL"],
            "Texas Orange": ["S","M","L","XL","2XL","3XL","4XL"],
            "Light Pink": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Pink Lemonade": ["S","M","L","XL","2XL","3XL","4XL"],
            "Red": ["S","M","L","XL","2XL","3XL","4XL","5XL"],
  
            "Cardinal": ["S","M","L","XL","2XL","3XL","4XL"],
            "Maroon": ["S","M","L","XL","2XL","3XL","4XL"],
            "Pistachio": ["S","M","L","XL","2XL","3XL","4XL"],
            "Sage": ["S","M","L","XL","2XL","3XL","4XL"],
            "Military Green": ["S","M","L","XL","2XL","3XL","4XL"],
  
            "Forest Green": ["S","M","L","XL","2XL","3XL","4XL"],
            "Sky": ["S","M","L","XL","2XL","3XL","4XL"],
            "Carolina Blue": ["S","M","L","XL","2XL","3XL","4XL"],
            "Stone Blue": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Aquatic": ["S","M","L","XL","2XL","3XL","4XL"],
  
            "Cobalt": ["S","M","L","XL","2XL","3XL","4XL"],
            "Blue Dusk": ["S","M","L","XL","2XL","3XL","4XL"],
            "Royal": ["S","M","L","XL","2XL","3XL","4XL"],
            "Navy": ["S","M","L","XL","2XL","3XL","4XL","5XL"],
            "Paragon": ["S","M","L","XL","2XL","3XL","4XL"],
  
            "Purple": ["S","M","L","XL","2XL","3XL","4XL"],
            "Brown Savana": ["S","M","L","XL","2XL","3XL","4XL"],
            "Cocoa": ["S","M","L","XL","2XL","3XL","4XL"]
          }
        }
      },
  
      "Long Sleeve": {
        G540: {
          colors: {
            "White": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Ash": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Sport Gray": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Charcoal": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Graphite Heather": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Dark Heather": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Black": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Gold": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Orange": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Safety Orange": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Light Pink": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Cardinal Red": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Red": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Maroon": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Irish Green": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Safety Green": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Military Green": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Forest Green": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Light Blue": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Carolina Blue": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Indigo Blue": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Royal": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Navy": ["S", "M", "L", "XL", "2XL", "3XL"],
            "Purple": ["S", "M", "L", "XL", "2XL", "3XL"]
          }
        }
      },
  
      "Sweatshirt": {
        G180: {
          colors: {
            "White": ["XS","S","M","L","XL","2XL","3XL","4XL","5XL"],
            "Ash": ["XS","S","M","L","XL","2XL","3XL","4XL","5XL"],
            "Graphite Heather": ["S","M","L","XL","2XL","3XL","4XL","5XL"],
            "Sport Gray": ["XS","S","M","L","XL","2XL","3XL","4XL","5XL"],
  
            "Charcoal": ["S","M","L","XL","2XL","3XL","4XL","5XL"],
            "Dark Heather": ["XS","S","M","L","XL","2XL","3XL","4XL","5XL"],
            "Black": ["XS","S","M","L","XL","2XL","3XL","4XL","5XL"],
            "Fan Heather Charcoal": ["S","M","L","XL","2XL","3XL","4XL"],
  
            "Gold": ["S","M","L","XL","2XL","3XL","4XL","5XL"],
            "Orange": ["S","M","L","XL","2XL","3XL","4XL","5XL"],
            "Light Pink": ["XS","S","M","L","XL","2XL","3XL","4XL","5XL"],
            "Safety Pink": ["S","M","L","XL","2XL","3XL","4XL","5XL"],
            "Heliconia": ["XS","S","M","L","XL","2XL","3XL","4XL","5XL"],
  
            "Cardinal Red": ["S","M","L","XL","2XL","3XL","4XL","5XL"],
            "Heather Sport Scarlet Red": ["S","M","L","XL","2XL","3XL","4XL","5XL"],
            "Maroon": ["S","M","L","XL","2XL","3XL","4XL","5XL"],
            "Red": ["XS","S","M","L","XL","2XL","3XL","4XL","5XL"],
            "Cherry Red": ["S","M","L","XL","2XL","3XL","4XL","5XL"],
  
            "Heather Sport Dark Maroon": ["S","M","L","XL","2XL","3XL","4XL","5XL"],
            "Garnet": ["S","M","L","XL","2XL","3XL","4XL","5XL"],
            "High Viz Safety Green": ["S","M","L","XL","2XL","3XL","4XL","5XL"],
            "Military Green": ["S","M","L","XL","2XL","3XL","4XL","5XL"],
  
            "Heather Sport Dark Green": ["S","M","L","XL","2XL","3XL","4XL","5XL"],
            "Fan Dark Green": ["S","M","L","XL","2XL","3XL","4XL"],
            "Irish Green": ["S","M","L","XL","2XL","3XL","4XL","5XL"],
            "Forest Green": ["S","M","L","XL","2XL","3XL","4XL","5XL"],
  
            "Light Blue": ["S","M","L","XL","2XL","3XL","4XL","5XL"],
            "Carolina Blue": ["S","M","L","XL","2XL","3XL","4XL","5XL"],
            "Sapphire": ["S","M","L","XL","2XL","3XL","4XL","5XL"],
            "Indigo Blue": ["S","M","L","XL","2XL","3XL","4XL","5XL"],
            "Neon Blue": ["S","M","L","XL","2XL","3XL","4XL"],
  
            "Royal": ["XS","S","M","L","XL","2XL","3XL","4XL","5XL"],
            "Heather Deep Royal": ["S","M","L","XL","2XL","3XL","4XL","5XL"],
            "Fan Deep Royal": ["S","M","L","XL","2XL","3XL","4XL"],
            "Navy": ["XS","S","M","L","XL","2XL","3XL","4XL","5XL"],
  
            "Purple": ["S","M","L","XL","2XL","3XL","4XL","5XL"],
            "Sand": ["XS","S","M","L","XL","2XL","3XL","4XL","5XL"],
            "Dark Chocolate": ["S","M","L","XL","2XL","3XL","4XL","5XL"]
          }
        }
      }
    },
  
    BC: {
      "Cropped Hoodie": {
        B7502: {
          colors: {
            Peach: ["S", "M", "L", "XL", "2XL"]
          }
        }
      },
  
      "Short Sleeve": {
        "3001C": {
          colors: {
            "White": ["XS","S","M","L","XL","2XL","3XL","4XL","5XL"],
            "Natural": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Vintage White": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Ash": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Silver": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Athletic Heather": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Heather Dust": ["XS","S","M","L","XL","2XL","3XL","4XL"],
  
            "Storm": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Dark Gray": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Asphalt": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Slate": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Heather Slate": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Black": ["XS","S","M","L","XL","2XL","3XL","4XL","5XL"],
            "Vintage Black": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Heather Black": ["XS","S","M","L","XL","2XL","3XL","4XL","5XL"],
  
            "Yellow": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Maize Yellow": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Mustard": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Gold": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Sunset": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Peach": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Heather Peach": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Terracotta": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Coral": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Orange": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Heather Orange": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Autumn": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Heather Autumn": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Burnt Orange": ["XS","S","M","L","XL","2XL","3XL","4XL"],
  
            "Soft Pink": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Lilac": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Pink": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Orchid": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Charity Pink": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Fuchsia": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Mauve": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Heather Mauve": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Heather Prism Peach": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Heather Prism Lilac": ["XS","S","M","L","XL","2XL","3XL","4XL"],
  
            "Berry": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Vintage Red": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Poppy": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Canvas Red": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Red": ["XS","S","M","L","XL","2XL","3XL","4XL","5XL"],
            "Heather Red": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Cardinal": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Heather Cardinal": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Rust": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Maroon": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Heather Maroon": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Oxblood": ["XS","S","M","L","XL","2XL","3XL","4XL"],
  
            "Mint": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Heather Mint": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Citron": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Spring Green": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Thyme": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Sage": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Heather Sage": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Army": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Pine": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Teal": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Olive": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Leaf": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Kelly": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Heather Green": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Heather Kelly": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Military Green": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Heather Military Green": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Forest": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Heather Forest": ["XS","S","M","L","XL","2XL","3XL","4XL"],
  
            "Atlantic": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Vintage Denim": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Light Blue": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Baby Blue": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Carolina Blue": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Dusty Blue": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Ocean Blue": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Aqua": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Columbia Blue": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Heather Columbia Blue": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Steel Blue": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Turquoise": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Electric Blue": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Deep Teal": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Heather Deep Teal": ["XS","S","M","L","XL","2XL","3XL","4XL","5XL"],
            "Marine": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Cool Blue": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Navy": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Heather Navy": ["XS","S","M","L","XL","2XL","3XL","4XL","5XL"],
            "True Royal": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Heather True Royal": ["XS","S","M","L","XL","2XL","3XL","4XL"],
  
            "Lavender Dust": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Dark Lavender": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Light Violet": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Royal Purple": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Purple Storm": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Team Purple": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Heather Purple": ["XS","S","M","L","XL","2XL","3XL","4XL"],
  
            "Soft Cream": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Sand Dune": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Tan": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Chestnut": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Toast": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Clay": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Pebble": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Vintage Brown": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Cocoa": ["XS","S","M","L","XL","2XL","3XL","4XL"],
            "Brown": ["XS","S","M","L","XL","2XL","3XL","4XL"]
          }
        }
      },
  
      "Cropped Short Sleeve": {
        "6482": {
          colors: {
            "White": ["XS","S","M","L","XL","2XL"],
            "Vintage White": ["XS","S","M","L","XL","2XL"],
            "Heather Athletic": ["XS","S","M","L","XL","2XL"],
            "Black": ["XS","S","M","L","XL","2XL"],
            "Mustard": ["XS","S","M","L","XL","2XL"],
            "Military Green": ["XS","S","M","L","XL","2XL"]
          }
        }
      },
  
      "Long Sleeve": {
        "3501": {
          colors: (() => {
            const colors = {};
  
            const allColors = [
              "White","Natural","Ash","Silver",
              "Storm","Dark Gray","Asphalt","Charcoal Black Slub","Solid Black Slub",
              "Vintage Black","Black","Soft Cream","Gold","Mustard",
              "Orange","Pink","Mauve","Berry","Poppy","Red","Cardinal","Maroon","Canvas Red",
              "Citron","Mint","Strobe","Teal","Olive","Military Green",
              "Forest","Kelly","Baby Blue","Carolina Blue","Lavender Blue",
              "Blue Storm","Steel Blue","Atlantic","True Royal","Vintage Navy","Navy",
              "Light Violet","Dark Lavender","Team Purple","Sand Dune","Terracotta",
              "Chestnut","Toast","Vintage Brown",
  
              "Solid White Blend","Heather Natural","Heather Athletic","Heather Dark Gray",
              "Heather Deep","Heather Black","Solid Black Blend","Heather French Vanilla",
              "Heather Mustard","Heather Yellow Gold","Heather Peach","Heather Mauve",
              "Heather Pink Gravel","Heather Clay","Heather Red","Heather Maroon",
              "Heather Cardinal","Heather Stone","Heather Forest","Heather Olive",
              "Heather Military Green","Heather Carolina Blue","Heather Columbia Blue",
              "Heather Dusty Blue","Heather Deep Teal","Heather Slate",
              "Heather True Royal","Heather Navy","Heather Midnight Navy",
              "Heather Dark Lavnder","Heather Brown",
  
              "Solid White Triblend","Oatmeal Triblend","Athletic Gray Triblend","Gray Triblend",
              "Solid Dark Gray Triblend","Charcoal Black Triblend","Solid Black Triblend",
              "Heather Black Triblend","Mauve Triblend","Brick Triblend","Red Triblend",
              "Maroon Triblend","Olive Triblend","Emerald Triblend","Blue Triblend",
              "Denim Triblend","True Royal Triblend","Navy Triblend","Solid Navy Triblend"
            ];
  
            const up4xl = ["White","Black","Heather Athletic","Heather Dark Gray"];
  
            const down2xl = [
              "Athletic Gray Triblend",
              "Solid Black Triblend",
              "Emerald Triblend",
              "Denim Triblend",
              "Brick Triblend"
            ];
  
            allColors.forEach(color => {
              if (down2xl.includes(color)) {
                colors[color] = LS_DOWN_2XL;
              } else if (up4xl.includes(color)) {
                colors[color] = LS_UP_4XL;
              } else {
                colors[color] = LS_BASE;
              }
            });
  
            return colors;
          })()
        }
      },

      "Sweatshirt": {
        "3901": {
          colors: {
            "White": ["XS","S","M","L","XL","2XL","3XL"],
            "Natural": ["XS","S","M","L","XL","2XL","3XL"],
            "Heather Dust": ["XS","S","M","L","XL","2XL","3XL"],
            "Ash": ["XS","S","M","L","XL","2XL","3XL"],
            "Heather Athletic": ["XS","S","M","L","XL","2XL","3XL"],
            "Gray Acid Fleece": ["XS","S","M","L","XL","2XL","3XL"],
            "Gray Triblend": ["XS","S","M","L","XL","2XL"],
            "Heather Deep": ["XS","S","M","L","XL","2XL","3XL"],
            "Heather Dark Gray": ["XS","S","M","L","XL","2XL","3XL"],
            "Silver": ["XS","S","M","L","XL","2XL","3XL"],
            "Asphalt": ["XS","S","M","L","XL","2XL","3XL"],
            "Heather Black": ["XS","S","M","L","XL","2XL","3XL"],
            "Black": ["XS","S","M","L","XL","2XL","3XL"],
            "Vintage Black": ["XS","S","M","L","XL","2XL","3XL"],
            "Heather Mustard": ["XS","S","M","L","XL","2XL","3XL"],
            "Mauve": ["XS","S","M","L","XL","2XL","3XL"],
            "Pink": ["XS","S","M","L","XL","2XL","3XL"],
            "Red": ["XS","S","M","L","XL","2XL","3XL"],
            "Maroon": ["XS","S","M","L","XL","2XL","3XL"],
            "Cardinal": ["XS","S","M","L","XL","2XL","3XL"],
            "Heather Red": ["XS","S","M","L","XL","2XL","3XL"],
            "Heather Forest": ["XS","S","M","L","XL","2XL","3XL"],
            "Forest": ["XS","S","M","L","XL","2XL","3XL"],
            "Heather Olive": ["XS","S","M","L","XL","2XL","3XL"],
            "Military Green": ["XS","S","M","L","XL","2XL","3XL"],
            "Heather Deep Teal": ["XS","S","M","L","XL","2XL","3XL"],
            "Lavender Blue": ["XS","S","M","L","XL","2XL","3XL"],
            "Heather Blue Lagoon": ["XS","S","M","L","XL","2XL","3XL"],
            "Blue Storm": ["XS","S","M","L","XL","2XL","3XL"],
            "Carolina Blue": ["XS","S","M","L","XL","2XL","3XL"],
            "Heather True Royal": ["XS","S","M","L","XL","2XL","3XL"],
            "True Royal": ["XS","S","M","L","XL","2XL","3XL"],
            "Navy": ["XS","S","M","L","XL","2XL","3XL"],
            "Heather Navy": ["XS","S","M","L","XL","2XL","3XL"],
            "Team Purple": ["XS","S","M","L","XL","2XL","3XL"],

            // "Light Gray Marble": ["XS","S","M","L","XL","2XL"],
            // "Dark Gray Marble Fleece": ["XS","S","M","L","XL","2XL"],
            // "Dark Gray": ["XS","S","M","L","XL","2XL","3XL"],
            // "Heather Deep / Black": ["XS","S","M","L","XL","2XL"],
            // "Heather Deep / Navy": ["XS","S","M","L","XL","2XL"],
            // "French Vanilla": ["XS","S","M","L","XL","2XL","3XL"],
            // "Gold": ["XS","S","M","L","XL","2XL","3XL"],
            // "Peach": ["XS","S","M","L","XL","2XL","3XL"],
            // "Brick": ["XS","S","M","L","XL","2XL","3XL"],
            // "Autumn": ["XS","S","M","L","XL","2XL","3XL"],
            // "Red Marble Fleck": ["XS","S","M","L","XL","2XL"],
            // "Cardinal Triblend": ["XS","S","M","L","XL","2XL"],
            // "Navy Triblend": ["XS","S","M","L","XL","2XL"]
          }
        }
      },

      "Hoodie": {
        "3719": {
          colors: (() => {
            const colors = {};

            const base = ["XS","S","M","L","XL","2XL","3XL"];
            const up4xl = ["XS","S","M","L","XL","2XL","3XL","4XL"];
            const down2xl = ["XS","S","M","L","XL","2XL"];

            const allColors = [
              "White","Vintage White","Natural",
              "Ash","Storm","Heather Athletic","Heather Deep","Heather Dark Gray","Dark Gray",
              "Asphalt","Silver","Heather Black","Black","Vintage Black","Heather Dust",
              "Heather Mustard",
              "Orange","Heather Charity Pink","Mauve","Pink",
              "Heather Red","Red","Heather Maroon","Maroon","Cardinal",
              "Teal","Heather Forest","Military Green","Forest","Kelly","Heather Olive",
              "Lavender Blue","Dusty Blue","Heather Blue Lagoon","Blue Storm",
              "Heather Deep Teal","Heather Slate","Atlantic","Heather Columbia Blue",
              "Steel Blue","Carolina Blue",
              "Heather True Royal","True Royal","Heather Navy","Navy",
              "Dark Lavender","Team Purple","Heather Team Purple",
              "Tan","Vintage Brown"
            ];

            const up4xlColors = ["Black","Heather Dark Gray","Heather Athletic"];
            const down2xlColors = ["Mauve","Pink","Heather Charity Pink"];

            allColors.forEach(color => {
              if (down2xlColors.includes(color)) {
                colors[color] = down2xl;
              } else if (up4xlColors.includes(color)) {
                colors[color] = up4xl;
              } else {
                colors[color] = base;
              }
            });

            return colors;
          })()
        }
      },

      "Cropped Hoodie": {
        "B7502": {
          colors: {
            "White": ["S","M","L","XL","2XL"],
            "Heather Dust": ["S","M","L","XL","2XL"],
            "Storm": ["S","M","L","XL","2XL"],
            "Heather Dark Gray": ["S","M","L","XL","2XL"],
            "Black": ["S","M","L","XL","2XL"],
            "Military Green": ["S","M","L","XL","2XL"]

            // "Heather Deep": ["S","M","L","XL","2XL"],
            // "Heather Mustard": ["S","M","L","XL","2XL"],
            // "Peach": ["S","M","L","XL","2XL"],
            // "Pink": ["S","M","L","XL","2XL"],
            // "Mauve": ["S","M","L","XL","2XL"],
            // "Atlantic": ["S","M","L","XL","2XL"],
            // "Navy": ["S","M","L","XL","2XL"],
            // "Team Purple": ["S","M","L","XL","2XL"]
          }
        }
      }
    },
  
    CC: {
      "Short Sleeve": {
        "CC1745": {
          colors: {
            "Smoke": ["S","M","L","XL","2XL","3XL"],
            "Citrine": ["S","M","L","XL","2XL","3XL"],
            "Umber": ["S","M","L","XL","2XL","3XL"],
            "Hibiscus": ["S","M","L","XL","2XL","3XL"],
            "Clay": ["S","M","L","XL","2XL","3XL"],
            "Sea Glass": ["S","M","L","XL","2XL","3XL"],
            "Fern": ["S","M","L","XL","2XL","3XL"],
            "Fiji Blue": ["S","M","L","XL","2XL","3XL"],
            "Ocean": ["S","M","L","XL","2XL","3XL"],
            "Amethyst": ["S","M","L","XL","2XL","3XL"]
          }
        },
    
        "C1717": {
          colors: (() => {
            const base = ["S","M","L","XL","2XL","3XL","4XL"];
            const colors = {};
    
            const allColors = [
              "White","Gray","Granite","Graphite","Pepper","Black",
              "Sandstone","Khaki","Butter","Neon Lemon","Citrus","Mustard",
              "Peachy","Neon Red Orange","Neon Cantaloupe","Bright Salmon",
              "Terracotta","Melon","Bright Orange","Burnt Orange","Yam",
              "Blossom","Neon Pink","Crunchberry","Watermelon","Red","Paprika",
              "Crimson","Berry","Chili","Brick","Island Reef","Bay",
              "Chalky Mint","Moss","Seafoam","Island Green","Sage",
              "Blue Spruce","Light Green","Hemp","Emerald",
              "Washed Denim","Denim","Chambray","Hydrangea","Lagoon Blue",
              "Flo Blue","Sapphire","Mystic Blue","Ice Blue","Periwinkle",
              "Blue Jean","China Blue","Midnight","Royal Caribe","Dusk",
              "True Navy","Navy","Orchid","Neon Violet","Violet","Grape",
              "Wine","Espresso","Rose Quartz","Ivory"
            ];
    
            allColors.forEach(c => colors[c] = base);
            return colors;
          })()
        }
      },
    
      "Long Sleeve": {
        "C6014": {
          colors: (() => {
            const base = ["S","M","L","XL","2XL","3XL","4XL"];
            const up3xl = ["S","M","L","XL","2XL","3XL"];
            const up2xl = ["S","M","L","XL","2XL"];
    
            const colors = {};
    
            const allColors = [
              "White","Ivory","Gray","Granite","Graphite","Pepper","Black",
              "Khaki","Butter","Mustard","Neon Yellow","Peachy","Melon",
              "Bright Salmon","Terracotta","Neon Red Orange","Burnt Orange","Mango",
              "Blossom","Watermelon","Neon Pink",
              "Heliconia","Red","Brick",
              "Crimson",
              "Island Reef",
              "Chalky Mint","Light Green","Seafoam","Island Green","Blue Spruce",
              "Hemp","Washed Denim","Denim","Hydrangea","Chambray","Lagoon Blue","Ice Blue","Flo Blue",
              "China Blue","Midnight","Blue Jean","Royal Caribe","True Navy","Navy",
              "Orchid","Violet","Berry","Grape",
              "Espresso"
            ];
    
            const limit3xl = ["Peachy","Melon","Hydrangea","Espresso"];
            const limit2xl = ["Neon Yellow"];
    
            allColors.forEach(color => {
              if (limit2xl.includes(color)) {
                colors[color] = up2xl;
              } else if (limit3xl.includes(color)) {
                colors[color] = up3xl;
              } else {
                colors[color] = base;
              }
            });
    
            return colors;
          })()
        }
      },
    
      "Sweatshirt": {
        "1566": {
          colors: {
            "White": ["S","M","L","XL","2XL","3XL"],
            "Gray": ["S","M","L","XL","2XL","3XL"],
            "Pepper": ["S","M","L","XL","2XL","3XL"],
            "Butter": ["S","M","L","XL","2XL","3XL"],
            "Terracotta": ["S","M","L","XL","2XL","3XL"],
            "Watermelon": ["S","M","L","XL","2XL","3XL"],
            "Crimson": ["S","M","L","XL","2XL","3XL"],
            "Seafoam": ["S","M","L","XL","2XL","3XL"],
            "Chalky Mint": ["S","M","L","XL","2XL","3XL"],
            "Light Green": ["S","M","L","XL","2XL","3XL"],
            "Blue Spruce": ["S","M","L","XL","2XL","3XL"],
            "Denim": ["S","M","L","XL","2XL","3XL"],
            "Chambray": ["S","M","L","XL","2XL","3XL"],
            "Flo Blue": ["S","M","L","XL","2XL","3XL"],
            "Blue Jean": ["S","M","L","XL","2XL","3XL"],
            "True Navy": ["S","M","L","XL","2XL","3XL"],
            "Orchid": ["S","M","L","XL","2XL","3XL"],
            "Violet": ["S","M","L","XL","2XL","3XL"]
          }
        }
      },
    
      "Hoodie": {
        "1567": {
          colors: {
            "White": ["S","M","L","XL","2XL","3XL"],
            "Gray": ["S","M","L","XL","2XL","3XL"],
            "Pepper": ["S","M","L","XL","2XL","3XL"],
            "Crimson": ["S","M","L","XL","2XL","3XL"],
            "Seafoam": ["S","M","L","XL","2XL","3XL"],
            "Light Green": ["S","M","L","XL","2XL","3XL"],
            "Blue Spruce": ["S","M","L","XL","2XL","3XL"],
            "Denim": ["S","M","L","XL","2XL","3XL"],
            "Flo Blue": ["S","M","L","XL","2XL","3XL"],
            "Blue Jean": ["S","M","L","XL","2XL","3XL"],
            "True Navy": ["S","M","L","XL","2XL","3XL"]
    
            // "Lagoon Blue": ["S","M","L","XL","2XL","3XL"]
          }
        }
      }
    }
  }
};


window.BRAND_OPTIONS = [
  { code: "GL", label: "Gildan" },
  { code: "BC", label: "Bella Canvas" },
  { code: "CC", label: "Comfort Colors" },
  { code: "TD", label: "Tie-Dye" },
  { code: "RS", label: "Rabbit Skins" }
];